import { render, staticRenderFns } from "./pad.vue?vue&type=template&id=734ec856"
import script from "./pad.vue?vue&type=script&lang=js"
export * from "./pad.vue?vue&type=script&lang=js"
import style0 from "./pad.vue?vue&type=style&index=0&id=734ec856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports